import React from 'react';
import { motion } from 'framer-motion';
import './ReasonRaving.css';
const ReasonRaving = () => {
  return (
    <div className='reason-raving-container'>
      {/* <div className='button-container'> */}
        <motion.button
          className='testimonial-button'
          whileHover={{
            boxShadow:
              '0 0 5px black, 0 0 10px black, 0 0 15px white, 0 0 20px black',
            transition: { duration: 0.5 },
          }}
          whileTap={{
            scale: 0.9,
            transition: { duration: 0.2 },
          }}
        >
          Testimonials
        </motion.button>
      {/* </div> */}
      <div className='heading-container'>
        <h1 className='framer-text'>
          There's a reason people<br/> are <span className='italic'>raving</span> about us.
        </h1>
      </div>
    </div>
  );
};

export default ReasonRaving;
